class CartRemoveButton extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', (event) => {
      event.preventDefault()
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items')
      cartItems.updateQuantity(this.dataset.index, 0, event)
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
  constructor() {
    super()

    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus')

    const debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, ON_CHANGE_DEBOUNCE_TIMER)

    this.addEventListener('change', debouncedOnChange.bind(this))
  }

  cartUpdateUnsubscriber = undefined

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return
      }
      return this.onCartUpdate()
    })
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber()
    }
  }

  resetQuantityInput(id) {
    const input =
      this.querySelector(`#Quantity-${id}`) || this.querySelector(`#Drawer-quantity-${id}`)
    input.value = input.getAttribute('value')
    this.isEnterPressed = false
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message)
    event.target.reportValidity()
    this.resetQuantityInput(index)
    if (typeof event.target.select !== 'undefined') {
      event.target.select()
    }
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value)
    const index = event.target.dataset.index
    let message = ''

    if (event.target.getAttribute('name') === 'updates[]') {
      const min = event.target.tagName === 'SELECT' ? 0 : event.target.dataset.min
      const max = event.target.tagName === 'SELECT' ? 1000 : event.target.max
      const step = event.target.tagName === 'SELECT' ? 1 : event.target.step

      if (inputValue < min) {
        message = window.quickOrderListStrings.min_error.replace('[min]', min)
      } else if (inputValue > parseInt(max)) {
        message = window.quickOrderListStrings.max_error.replace('[max]', max)
      } else if (inputValue % parseInt(step) !== 0) {
        message = window.quickOrderListStrings.step_error.replace('[step]', step)
      }
    }

    if (message) {
      this.setValidity(event, index, message)
    } else {
      event.target.setCustomValidity('')
      event.target.reportValidity()
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId,
      )
    }
  }

  onChange(event) {
    this.validateQuantity(event)
  }

  onCartUpdate() {
    const cartDrawer = this.closest('cart-drawer')
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const selectors = [
            '.drawer__heading',
            // 'cart-drawer-bxgy-bar',
            'cart-drawer-gwp',
            // 'cart-drawer-insiders-gwp',
            'cart-summary',
            'cart-drawer-items',
            // 'cart-drawer-gwp-test',
            'cart-drawer-insiders',
            // 'cart-drawer-addon-202502',
            // 'cart-drawer-addon-tabs',
            'cart-drawer-addon-infinite',
            // 'cart-drawer-collections',
            '.drawer__footer',
          ]
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector)
            const sourceElement = html.querySelector(selector)
            if (targetElement && sourceElement) {
              switch (selector) {
                case 'cart-drawer-gwp':
                  if (sourceElement.querySelector('.gwp-bar') !== null) {
                    this.setGwpBarPercentage(sourceElement, this.getGwpBarPercentage(targetElement))
                  }

                  if (sourceElement.querySelector('.shipping-progress-bar') !== null) {
                    this.setShippingBarProgress(
                      sourceElement,
                      this.getShippingBarProgress(targetElement),
                    )
                  }
                  break

                case 'cart-drawer-gwp-test':
                  if (sourceElement.querySelectorAll('.addon-item__progress-bar').length > 0) {
                    this.setAddonItemsProgress(sourceElement, targetElement)
                  }
                  break

                case 'cart-drawer-bxgy-bar':
                  this.setBxgyBarConfetti(sourceElement, targetElement)
                  this.setBxgyBarProgress(sourceElement, this.getBxgyBarProgress(targetElement))
                  break

                default:
              }
              targetElement.replaceWith(sourceElement)
            }
          }

          if (cartDrawer !== null) {
            cartDrawer.sectionRenderContent()
            cartDrawer.classList.remove('is-loading')
            cartDrawer.querySelector('.drawer__body').scrollTop = 0
          }
        })
        .catch((e) => {
          console.error(e)
        })
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const sourceQty = html.querySelector('cart-items')
          this.innerHTML = sourceQty.innerHTML
        })
        .catch((e) => {
          console.error(e)
        })
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ]
  }

  getGwpBarPercentage(element) {
    return element.querySelector('.gwp-bar').getAttribute('data-percentage')
  }

  setGwpBarPercentage(element, percentagetFrom) {
    element.querySelector('.gwp-bar').style.setProperty('--percentage-from', `${percentagetFrom}%`)
  }

  getShippingBarProgress(element) {
    return element.querySelector('.shipping-progress-bar').getAttribute('data-percentage')
  }

  setShippingBarProgress(element, percentagetFrom) {
    element
      .querySelector('.shipping-progress-bar')
      .style.setProperty('--percentage-from', `${percentagetFrom}%`)
  }

  setAddonItemsProgress(element, target) {
    element.querySelectorAll('.addon-item__progress-bar').forEach((bar) => {
      const targetBar = target.querySelector(
        `.addon-item__progress-bar[data-product-id="${bar.dataset.productId}"]`,
      )
      if (targetBar !== null) {
        let percentagetFrom = targetBar.dataset.percentage
        bar.style.setProperty('--percentage-from', `${percentagetFrom}%`)
      }
    })
  }

  getBxgyBarProgress(element) {
    const bxgyBarProgress = []
    element.querySelectorAll('.bxgy__bar li').forEach((item) => {
      bxgyBarProgress.push(item.getAttribute('data-progress'))
    })
    return bxgyBarProgress
  }

  setBxgyBarProgress(element, progress) {
    element.querySelectorAll('.bxgy__bar li').forEach((bxgyBarItem, index) => {
      bxgyBarItem.style.setProperty('--progress-from', `${progress[index]}`)
    })
  }

  setBxgyBarConfetti(sourceElement, targetElement) {
    const cartDrawer = this.closest('cart-drawer')
    if (cartDrawer.querySelector('.confetti') === null) {
      return
    }
    const targetEnableConfetti =
      targetElement.querySelector('[enable-confetti]').getAttribute('enable-confetti') === 'true'
    const sourceEnableConfetti =
      sourceElement.querySelector('[enable-confetti]').getAttribute('enable-confetti') === 'true'

    let enableAnimation = false
    if (!targetEnableConfetti && sourceEnableConfetti) {
      enableAnimation = true
    }

    const targetProgresses = []
    const sourceProgresses = []
    const newTiersUnlocked = []
    targetElement.querySelectorAll('.bxgy__bar li').forEach((ele) => {
      targetProgresses.push(ele.dataset.progress)
    })
    sourceElement.querySelectorAll('.bxgy__bar li').forEach((ele) => {
      sourceProgresses.push(ele.dataset.progress)
    })
    targetProgresses.forEach(function (targetProgress, i) {
      const sourceProgress = sourceProgresses[i]
      if (targetProgress !== '100' && sourceProgress === '100') {
        enableAnimation = true
        newTiersUnlocked.push(i + 1)
      }
    })

    newTiersUnlocked.forEach((tier) => {
      setTimeout(() => {
        const tierElement = cartDrawer.querySelector(`.bxgy__bar li[data-tier="${tier}"]`)
        if (tierElement !== null) {
          tierElement.classList.add('bxgy-bounce')
        }
      }, 1000)
    })

    if (enableAnimation) {
      setTimeout(() => {
        cartDrawer.querySelector('.confetti').style.display = 'flex'
      }, 1000)
      setTimeout(() => {
        cartDrawer.querySelector('.confetti').style.display = 'none'
      }, 4000)
    }
  }

  sendCartDataLayerEvent(eventName, product, index, quantity, method = null) {
    const customerData = JSON.parse(document.querySelector('.js-customer-json')?.innerHTML || '{}')
    const templateData = JSON.parse(document.querySelector('.js-template-json')?.innerHTML || '{}')

    let page_type = ''

    if (templateData.name == 'index') {
      page_type = 'homepage'
    } else if (templateData.name == 'collection') {
      page_type = 'collection page'
    } else if (templateData.name == 'product') {
      page_type = 'product detail page'
    } else if (templateData.name == 'page') {
      if (templateData.suffix == 'add-more-save-more') {
        page_type = 'bundle builder'
      } else {
        page_type = templateData.suffix || 'other'
      }
    } else {
      page_type = templateData.suffix || 'other'
    }

    const category1 = product.dataset.category1 || 'Unknown'
    const category2 = product.dataset.category2 || 'Unknown'
    const category3 = product.dataset.category3 || 'Unknown'
    const colors = product.dataset.colors || 'Unknown'
    const size = product.dataset.size || 'Unknown'
    const pack_size = product.dataset.packSize || 'Unknown'
    const vendor = product.dataset.vendor || 'Unknown'
    const product_price = product.dataset.productPrice || 'Unknown'
    const compare_at_price = product.dataset.productCompareAtPrice || 'Unknown'
    const product_id = product.dataset.productId || 'Unknown'
    const product_title = product.dataset.productTitle || 'Unknown'
    const cart_source = 'Rebuy Cart'

    const dataLayerEvent = {
      event: eventName,
      cart_source: cart_source,
      membership_status: customerData.membership_status,
      ...window.intelligemsMeta,
      ...(customerData.id && { userId: customerData.id }),
      page_type: page_type,
      color_pack: colors,
      login_status: customerData.has_account ? 'loggedin' : 'non_loggedin',
      pack_quantity: pack_size,
      ...(eventName === 'add_to_cart' && { pdp_type: 'popup' }),
      ecommerce: {
        currency: templateData.currency,
        value: (product.dataset.productPrice / 100) * quantity,
        items: [
          {
            item_id: Number(product_id),
            cart_source: cart_source,
            item_name: product_title,
            coupon: product.discounts ? product.discounts : '',
            discount: compare_at_price
              ? ((Number(compare_at_price) - Number(product_price)) * quantity) / 100
              : 0,
            index: Number(index) + 1,
            item_brand: vendor,
            item_category: category1,
            item_category2: category2,
            item_category3: compare_at_price
              ? ((Number(compare_at_price) - Number(product_price)) / Number(compare_at_price)) *
                100
              : 0,
            item_category4: size,
            item_category5: category3,
            item_list_id: '',
            item_list_name: '',
            item_variant: product.dataset.colors.toString(),
            price: Number(product_price) / 100,
            quantity: quantity,
            style_number: product.dataset.styleNumber ? product.dataset.styleNumber : '',
            sku_id: product.dataset.sku ? product.dataset.sku : '',
            variant_id: product.dataset.variantId ? product.dataset.variantId : '',
          },
        ],
      },
    }

    window.dataLayer.push(dataLayerEvent)
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line)

    const quantityElement =
      document.getElementById(`Quantity-${line}`) ||
      document.getElementById(`Drawer-quantity-${line}`)
    const currentQuantity = parseInt(quantityElement.getAttribute('value'))

    const lineItem =
      document.getElementById(`CartItem-${line}`) ||
      document.getElementById(`CartDrawer-Item-${line}`)
    const productJsonElement = lineItem ? lineItem.querySelector('[data-product-json]') : null

    if (productJsonElement) {
      if (quantity > currentQuantity) {
        const quantityAdded = quantity - currentQuantity
        this.sendCartDataLayerEvent('add_to_cart', productJsonElement, line - 1, quantityAdded)
      }
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change'

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)

        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) ||
            document.getElementById(`Drawer-quantity-${line}`)
          const items = document.querySelectorAll('.cart-item')

          if (parsedState.errors) {
            quantityElement.value = quantityElement.getAttribute('value')
            this.updateLiveRegions(line, parsedState.errors)
            return
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0)
          const cartDrawerWrapper = document.querySelector('cart-drawer')
          const cartFooter = document.getElementById('main-cart-footer')

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0)
          if (cartDrawerWrapper)
            cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0)

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id)
            if (
              elementToReplace.querySelector('.gwp-bar') !== null ||
              elementToReplace.querySelector('.bxgy__bar') !== null ||
              elementToReplace.querySelector('.shipping-progress-bar__bar') !== null ||
              elementToReplace.querySelectorAll('.addon-item__progress-bar').length > 0
            ) {
              const newSectionInnerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
              )
              const html = new DOMParser().parseFromString(newSectionInnerHTML, 'text/html')
              const sourceElement = html.querySelector('body')

              // Get previous state and alter before replacing drawer content
              this.setGwpBarPercentage(sourceElement, this.getGwpBarPercentage(elementToReplace))

              if (elementToReplace.querySelector('.shipping-progress-bar') !== null) {
                this.setShippingBarProgress(
                  sourceElement,
                  this.getShippingBarProgress(elementToReplace),
                )
              }

              if (elementToReplace.querySelectorAll('.addon-item__progress-bar').length > 0) {
                this.setAddonItemsProgress(sourceElement, elementToReplace)
              }

              // this.setBxgyBarProgress(sourceElement, this.getBxgyBarProgress(elementToReplace))
              // this.setBxgyBarConfetti(sourceElement, elementToReplace)

              // swap addon content to avoid further API call for section rending
              const addonContentSelector = 'cart-drawer-addon-infinite-content'
              if (elementToReplace.querySelector(addonContentSelector) !== null) {
                sourceElement.querySelector(addonContentSelector).innerHTML =
                  elementToReplace.querySelector(addonContentSelector).innerHTML
              }
              elementToReplace.innerHTML = sourceElement.innerHTML
            } else {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector,
              )
            }
          })
          const updatedValue = parsedState.items[line - 1]
            ? parsedState.items[line - 1].quantity
            : undefined
          let message = ''
          if (
            items.length === parsedState.items.length &&
            updatedValue !== parseInt(quantityElement.value)
          ) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue)
            }
          }

          this.gwpCheck(parsedState, event)
          this.updateLiveRegions(line, message)

          const lineItem =
            document.getElementById(`CartItem-${line}`) ||
            document.getElementById(`CartDrawer-Item-${line}`)
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus()
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(
              cartDrawerWrapper.querySelector('.drawer__inner-empty'),
              cartDrawerWrapper.querySelector('a'),
            )
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
          }
        })

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event)

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: variantId,
        })

        const cartDrawer = document.querySelector('cart-drawer')
        if (cartDrawer !== null && typeof cartDrawer.sectionRenderContent === 'function') {
          cartDrawer.sectionRenderContent()
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner, .loading__skeleton').forEach((overlay) =>
          overlay.classList.add('hidden'),
        )
        const errors =
          document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
      })
      .finally(() => {
        this.disableLoading(line)
        document.dispatchEvent(new CustomEvent('cartupdatesuccess'))
      })
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`)
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message

    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.add('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner, #CartItem-${line} .loading__skeleton`,
    )
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner, #CartDrawer-Item-${line} .loading__skeleton`,
    )

    ;[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove('hidden'),
    )

    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.remove('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner, #CartItem-${line} .loading__skeleton`,
    )
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner, #CartDrawer-Item-${line} .loading__skeleton`,
    )

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'))
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'))
  }

  gwpCheck(parsedState, event) {
    const keysToRemove = []
    parsedState.items.forEach((item, index) => {
      if (item.properties?._free === 'true' && item.final_line_price > 0) {
        keysToRemove.push(item.key)
      }
    })

    if (keysToRemove.length > 0) {
      let updates = {}
      keysToRemove.forEach((key) => {
        updates[key] = 0
      })
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      })
        .then((response) => {
          return response.text()
        })
        .then((state) => {
          const parsedState = JSON.parse(state)
          // console.log('then', parsedState)
          document.querySelector('#cart-icon-bubble .cart-count').innerHTML = parsedState.item_count
        })
        .catch((error) => {
          this.querySelectorAll('.loading__spinner, .loading__skeleton').forEach((overlay) =>
            overlay.classList.add('hidden'),
          )
          const errors =
            document.getElementById('cart-errors') ||
            document.getElementById('CartDrawer-CartErrors')
          errors.textContent = window.cartStrings.error
        })
        .finally(() => {
          this.onCartUpdate()
          document.dispatchEvent(new CustomEvent('cartupdatesuccess'))
        })
    }
  }
}

customElements.define('cart-items', CartItems)

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super()

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value })
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(() =>
              CartPerformance.measureFromEvent('note-update:user-action', event),
            )
          }, ON_CHANGE_DEBOUNCE_TIMER),
        )
      }
    },
  )
}
